import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuthStore } from './stores/auth.store';
import AdminLayout from './layouts/AdminLayout';
import LoginPage from './pages/login';
import { routes } from './config/routes';

/**
 * 应用根组件
 *
 * 负责路由分发和认证守卫：
 * - 未登录用户只能访问登录页
 * - 已登录用户根据角色权限渲染对应路由
 */
const App: React.FC = () => {
  const { token, user } = useAuthStore();
  const loading = useAuthStore((s) => s.loading);

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Spin size="large" tip="加载中..." />
      </div>
    );
  }

  return (
    <Routes>
      {/* 公开路由 */}
      <Route
        path="/login"
        element={
          token && user ? <Navigate to="/dashboard" replace /> : <LoginPage />
        }
      />

      {/* 受保护路由 */}
      <Route
        path="/*"
        element={
          token && user ? (
            <AdminLayout>
              <Routes>
                {routes.map((route) => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={route.element}
                  />
                ))}
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </AdminLayout>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
    </Routes>
  );
};

export default App;
